(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("popconfirm", [], factory);
	else if(typeof exports === 'object')
		exports["popconfirm"] = factory();
	else
		root["popconfirm"] = factory();
})(this, function() {
return 